import * as angular from "angular";
import * as _ from "lodash";
import * as PhoneFormat from "phoneformat.js";

angular
  .module('bringoz.admin.commons')
  .filter('bringozPhonePrefix', bringozPhonePrefix);

function bringozPhonePrefix(splitService) {
  return function bringozPhoneFilter(phoneNumber) {
    if (_.isUndefined(phoneNumber)) {
      return;
    }

    const country = splitService.getCountryCode();
    return PhoneFormat.formatE164(country, phoneNumber);
  };
}
